export interface Organization {
  orgId: string;
  name: string;
  address: string;
  country?: string;
  email: string;
  creationDate?: Date;
  scopeName?: string;
  distId?: string;
  products?: { serialNo: string; hardwareModel?: string; alias?: string; scopeName?: string }[];
  lastUpdateDate?: Date;
  isActive?: boolean;
  accountType?: AccountType[];
  accountInfo?: string;
  logoUrl?: string;
  logoFile?: File | null;
}

export type AccountType =
  | "university"
  | "updater"
  | "hospital"
  | "school"
  | "optometrist"
  | "optician"
  | "ophthalmologist"
  | "orthoptist"
  | "trial"
  | "study"
  | "nonprofit"
  | "other"
  | "subscription"
  | "rental"
  | "congress"
  | "demo"
  | "distributor";

export type AccountTypeForVersionManagement = "demo" | "distributor";

export const AccountTypeForVersionManagementValues: AccountTypeForVersionManagement[] = [
  "demo",
  "distributor",
];
